import { IRequestContext } from '@msdyn365-commerce/core-internal';
import { useCallback, useEffect, useState } from 'react';
import { AutosuggestSearchParams } from '../services/SearchService';
import { useMappingService, useSearchService } from './serviceHooks';
import { SearchSuggestions } from '../types/mapped';

export type UseSearchSuggestionsParams = AutosuggestSearchParams & {
    request: IRequestContext;
};

export const useSearchSuggestions = (params: UseSearchSuggestionsParams) => {
    const {
        request,
        numberOfCategoryResults,
        numberOfKeywordResults,
        numberOfProductResults,
        query,
        shouldFetchCategories,
        shouldFetchProducts,
        shouldFetchSearchTermPredictions
    } = params;
    const [suggestions, setSuggestions] = useState<SearchSuggestions>();
    const [isLoading, setIsLoading] = useState(false);

    const relewiseMappingService = useMappingService(request);
    const relewiseSearchService = useSearchService(request);

    const fetchSuggestions = useCallback(async () => {
        if (!query) {
            setSuggestions(undefined);
            return;
        }

        setIsLoading(true);

        const result = await relewiseSearchService.autosuggestedSearch({
            numberOfCategoryResults,
            numberOfKeywordResults,
            numberOfProductResults,
            query,
            shouldFetchCategories,
            shouldFetchProducts,
            shouldFetchSearchTermPredictions
        });
        const mappedResult = relewiseMappingService.mapAutosuggestedSearchResult(result);

        setSuggestions(mappedResult);
        setIsLoading(false);
    }, [
        numberOfCategoryResults,
        numberOfKeywordResults,
        numberOfProductResults,
        query,
        shouldFetchCategories,
        shouldFetchProducts,
        shouldFetchSearchTermPredictions,
        relewiseMappingService,
        relewiseSearchService
    ]);

    useEffect(() => {
        fetchSuggestions();
    }, [query, fetchSuggestions]);

    return { suggestions, isLoading };
};
